// In assets/dsr-validation.js - KOMPLETT ERSETZEN

(function() {
  'use strict';
  
  let isValidating = false;
  
  async function validateDSRCart() {
    if (isValidating) return;
    isValidating = true;
    
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const itemsWithTags = await Promise.all(
        cart.items.map(async (item) => {
          try {
            const productResponse = await fetch(`/products/${item.handle}.js`);
            const product = await productResponse.json();
            return {
              ...item,
              product_tags: product.tags || []
            };
          } catch (e) {
            return { ...item, product_tags: [] };
          }
        })
      );
      
      const validation = checkDSRRules({ ...cart, items: itemsWithTags });
      
      if (validation !== true) {
        showCartError(validation);
        disableCheckout();
      } else {
        hideCartError();
        enableCheckout();
      }
    } catch (error) {
      console.error('DSR Validation Error:', error);
    } finally {
      isValidating = false;
    }
  }
  
  function checkDSRRules(cart) {
    const dsrItems = cart.items.filter(item => 
      item.sku && item.sku.startsWith('DSR')
    );
    
    if (dsrItems.length === 0) return true;
    
    if (cart.items.length !== dsrItems.length) {
      return "DSR-Artikel können nicht mit anderen Produkten kombiniert werden.";
    }
    
    const fassungItems = dsrItems.filter(item => 
      item.product_tags && item.product_tags.includes('collection:FASSUNG')
    );
    const schieneItems = dsrItems.filter(item => 
      item.product_tags && item.product_tags.includes('collection:SCHIENE')
    );
    
    if (fassungItems.length === 0 || schieneItems.length === 0) {
      return "Sie benötigen sowohl einen DSR-Artikel mit FASSUNG als auch mit SCHIENE im Warenkorb.";
    }
    
    if (fassungItems.length > 1) {
      return "Sie können nur einen DSR-Artikel aus der Kategorie FASSUNG in den Warenkorb legen.";
    }
    
    if (schieneItems.length > 1) {
      return "Sie können nur einen DSR-Artikel aus der Kategorie SCHIENE in den Warenkorb legen.";
    }
    
    const fassungQuantity = fassungItems.reduce((sum, item) => sum + item.quantity, 0);
    const schieneQuantity = schieneItems.reduce((sum, item) => sum + item.quantity, 0);
    
    if (fassungQuantity > 1) {
      return "Die maximale Bestellmenge für DSR FASSUNG-Artikel ist 1 Stück.";
    }
    
    if (schieneQuantity > 1) {
      return "Die maximale Bestellmenge für DSR SCHIENE-Artikel ist 1 Stück.";
    }
    
    return true;
  }
  
  function showCartError(message) {
    hideCartError();
    
    const errorDiv = document.createElement('div');
    errorDiv.id = 'dsr-cart-error';
    errorDiv.className = 'cart-error dsr-validation-error';
    errorDiv.style.cssText = 'background: #fee; border: 2px solid #c33; padding: 15px; margin: 20px 0; color: #c33; border-radius: 4px; font-weight: bold; font-size: 16px; position: relative; z-index: 9999; box-shadow: 0 2px 8px rgba(0,0,0,0.1); text-align: center;';
    errorDiv.innerHTML = `⚠️ ${message}`;
    
    // Spezifische Container für WSH Order Form
    const wshContainers = [
      'table',                          // Die Produkttabelle
      '.wsh-order-form',
      '.wsh-products-table',
      'form',
      '#MainContent',
      'main',
      '.main-content'
    ];
    
    let errorPlaced = false;
    
    // Versuche die Fehlermeldung über der Tabelle zu platzieren
    for (let selector of wshContainers) {
      const container = document.querySelector(selector);
      if (container && !errorPlaced) {
        // Wenn es eine Tabelle ist, füge die Meldung VOR der Tabelle ein
        if (selector === 'table') {
          container.parentNode.insertBefore(errorDiv, container);
        } else {
          container.insertBefore(errorDiv, container.firstChild);
        }
        errorPlaced = true;
        break;
      }
    }
    
    // Fallback: Füge am Anfang von main/body ein
    if (!errorPlaced) {
      const main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      main.insertBefore(errorDiv, main.firstChild);
    }
    
    // Zusätzlich: Zeige auch im normalen Warenkorb
    const cartContainers = [
      'form[action="/cart"]',
      '.cart-drawer__inner',
      '.cart-drawer',
      '[data-cart-items]',
      '.cart'
    ];
    
    for (let selector of cartContainers) {
      const container = document.querySelector(selector);
      if (container) {
        const cartError = errorDiv.cloneNode(true);
        cartError.id = 'dsr-cart-error-drawer';
        container.insertBefore(cartError, container.firstChild);
        break;
      }
    }
  }
  
  function hideCartError() {
    const errors = document.querySelectorAll('#dsr-cart-error, #dsr-cart-error-drawer, .dsr-validation-error');
    errors.forEach(error => error.remove());
  }
  
  function disableCheckout() {
    const checkoutSelectors = [
      '[name="checkout"]',
      '.cart__checkout',
      '[href*="/checkout"]',
      'button[type="submit"][name="checkout"]',
      '.wsh-checkout-button',
      'button[onclick*="checkout"]',
      'a[href*="checkout"]',
      '.checkout-button'
    ];
    
    const checkoutButtons = document.querySelectorAll(checkoutSelectors.join(', '));
    checkoutButtons.forEach(btn => {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
      btn.setAttribute('data-dsr-disabled', 'true');
      btn.addEventListener('click', preventCheckout, true);
    });
  }
  
  function preventCheckout(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  
  function enableCheckout() {
    const checkoutButtons = document.querySelectorAll('[data-dsr-disabled="true"]');
    checkoutButtons.forEach(btn => {
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.style.pointerEvents = 'auto';
      btn.removeAttribute('data-dsr-disabled');
      btn.removeEventListener('click', preventCheckout, true);
    });
  }
  
  function init() {
    // Initiale Validierung mit Verzögerung für WSH Order Form
    setTimeout(validateDSRCart, 1000);
    
    // Standard Events
    document.addEventListener('cart:updated', validateDSRCart);
    document.addEventListener('ajaxCart:updated', validateDSRCart);
    
    // WSH Events
    ['wsh:cart:updated', 'wsh:item:added', 'wsh:item:removed', 'wsh:quantity:changed',
     'cart.requestComplete', 'theme:cart:change'].forEach(event => {
      document.addEventListener(event, () => setTimeout(validateDSRCart, 300));
    });
    
    // MutationObserver für die gesamte Seite
    const observer = new MutationObserver(() => {
      setTimeout(validateDSRCart, 200);
    });
    
    const mainContent = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
    observer.observe(mainContent, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-count', 'class']
    });
    
    // Input-Änderungen
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="number"]') ||
          e.target.matches('[name*="quantity"]') ||
          e.target.matches('[name="updates[]"]')) {
        setTimeout(validateDSRCart, 400);
      }
    });
    
    // Click auf "Hinzufügen"-Buttons
    document.addEventListener('click', function(e) {
      const button = e.target.closest('button');
      if (button && (
          button.textContent.includes('Hinzufügen') ||
          button.textContent.includes('hinzufügen') ||
          button.classList.contains('wsh-add-button')
      )) {
        setTimeout(validateDSRCart, 1000);
      }
    });
    
    // Aggressives Polling auf WSH Order Form Seite
    let lastCartState = '';
    setInterval(async () => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const currentState = JSON.stringify(cart.items.map(i => ({ id: i.id, qty: i.quantity })));
        
        if (currentState !== lastCartState) {
          lastCartState = currentState;
          setTimeout(validateDSRCart, 200);
        }
      } catch (error) {
        // Ignoriere Fehler
      }
    }, 1500);
    
    // Validierung bei Seitenfokus
    window.addEventListener('focus', () => setTimeout(validateDSRCart, 500));
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
